<app-loading *ngIf="loadingData"></app-loading>

<div *ngIf="!loadingData" class="container-fluid">

  <div class="auction-breadcrumb" aria-label="breadcrumb">
    <div class="container-fluid top-breadcrumb">
      <div class="d-flex justify-content-between">
        <div class="auction-breadcrumb-active">
          {{roomdetails.name}}
        </div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#">{{"Home.Home"|translate}}</a></li>

          <li class="breadcrumb-item active" aria-current="page"> {{roomdetails.name}}</li>
        </ol>
      </div>
    </div>
  </div>
  <div class="multi-auction auction-actions mainAuction p-3">
    <!-- <div class="auction_info">
      <div class="row">
        <div class="col-lg-4 col-12 col-xl-3">
          <img [src]="roomdetails.image" class="main_image" [alt]="roomdetails?.name">
        </div>
        <div class="col-lg-5 col-12 col-xl-6 p-4">
          <p class="name">{{roomdetails?.name}}</p>
          <p class="description"> {{roomdetails?.description}}</p>
          <div class="items row">
            <div class="item col-md-6 col-12"><img src="./assets/images/icons/calender.svg" alt=""
                srcset=""><span>{{roomdetails.start_date | dateUTC}}</span></div>
            <div class="item col-md-6 col-12"><img src="./assets/images/icons/items.svg"
                alt=""><span>{{roomdetails.auctions_count}}
                {{"Main Auction.Items"|translate}}
              </span></div>
          </div>
        </div>
        <div class="col-lg-3 col-12 col-xl-3 px-4">
          <app-broadcast [auctionData]="roomdetails"></app-broadcast>
        </div>
      </div>



    </div> -->

    <div class="banner">
      <img class="bluredImage" [src]="roomdetails.image" onerror="this.src='assets/images/default-img.png'"
        [alt]="roomdetails.name + ' Banner'">
      <img class="baseImage" [src]="roomdetails.image" [alt]="roomdetails.name + ' Banner'"
        onerror="this.src='assets/images/default-img.png'">
    </div>

    <section class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <div class="details">
            <div class="title">{{roomdetails.name}}</div>
            <div class="desc">{{roomdetails.description}}</div>

            <div class="items ">
              <div class="item mb-0">
                <div class="entry_fee">
                  <div class="title">{{"multiAuction.Entry fee"|translate}}</div>
                  <div class="value">{{roomdetails.entry_fee}} {{"Home.SR"|translate}}</div>
                </div>

              </div>
              <div class="item "><img src="./assets/images/icons/calender.svg" alt=""
                  srcset=""><span>{{roomdetails.date_format_start_end}}</span></div>
              <div class="item "><img src="./assets/images/icons/calender.svg" alt=""
                  srcset=""><span>{{roomdetails.start_date |dateUTC:'hh:mm a'}}</span></div>
              <div class="item "><img src="./assets/images/icons/items.svg" alt=""><span>{{roomdetails.auctions_count}}
                  {{"Main Auction.Items"|translate}}
                </span></div>
              <div class="item " *ngIf="roomdetails?.permitting_without_enough_balance">
                <img src="./assets/images/icons/items.svg" alt="" [matTooltip]="'Auction Item.Allow biddig over your wallet'|translate">
                <span *ngIf="roomdetails?.is_percentage">
                  {{roomdetails.permitting_value}}%
                </span>
                <span *ngIf="!roomdetails?.is_percentage">
                  {{roomdetails.permitting_value}} {{"Auction Item.SR"|translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="streamMultiAuction col-12 col-md-auto">
          <app-broadcast [auctionData]="roomdetails"></app-broadcast>
        </div>
      </div>

    </section>

    <div class="row"
      [hidden]="!listginItem ||(!activeAuctionWork && roomdetails.type=='ongoing' && _config.getAuthUserInfo()?.user?.role_code=='General' && roomdetails.is_me_joined)">
      <div class="col-lg-4 col-md-12 order-lg-1 order-md-3">
        <app-list-items-auction [activeAuctionWork]="activeAuctionWork" [closedAuctionSocket]="closedAuctionSocket"
          [roomDetails]="roomdetails" (getItemsActive)="getItemsActive($event)" (listingItems)="allListginItem($event)"
          [reloadList]="reloadList"></app-list-items-auction>
      </div>
      <div class="col-lg-4 col-md-6 order-lg-2 order-md-1">
        <app-item-detailes-multi *ngIf="!loadingItemsDetalis && roomdetails" [itemDetails]="itemDetails"
          [newBidding]="newBidding" [activeAuctionWork]="activeAuctionWork" [roomdetails]="roomdetails"
          (getBidders)="getBidders($event)"></app-item-detailes-multi>
      </div>

      <div class="col-lg-4 col-md-6 order-lg-3 order-md-2">
        <span [ngSwitch]="CurrentCase">
          <div *ngSwitchCase="'pause'">
            <div class="auctionPaused">
              <img src="./assets/images/pauseIcon.svg" alt="">
              <div class="title">{{"multiAuction.The auction is temporarily paused"|translate}}</div>
              <div class="desc">
                {{"multiAuction.YoullBeAbleToContinueAuction"|translate}}</div>
            </div>
          </div>
          <div *ngSwitchCase="'not_available'">
            <div class="auctionPaused">
              <img src="./assets/images/notAvailable.svg" alt="">
              <div class="title">{{"multiAuction.Bidding is not available yet"|translate}}</div>
              <div class="desc">{{"multiAuction.You'll be able to bid on this auction when its turn comes"|translate}}
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'timer_between'">
            <div class="timerBetween">
              <div class="text">{{"multiAuction.This auction is going to start in"|translate}}</div>
              <div class="w-100" style="max-width: 150px;max-height:150px; ">
                <app-timer-circle-multi
                  [duration]="auctionRemainingTimeBetween.type=='second'? roomdetails.time_between_items:roomdetails.time_between_items*60"
                  [timeLeft]="auctionRemainingTimeBetween.remainingStart"></app-timer-circle-multi>
              </div>
            </div>
          </div>
          <p *ngSwitchDefault>
            <app-multi-live-bidding *ngIf="!loadingItemsDetalis" [itemDetails]="itemDetails" [listBidders]="listBidders"
              [auctionRemainingTime]="auctionRemainingTime" [activeAuctionWork]="activeAuctionWork"
              [auctionRemainingTimeBetween]="auctionRemainingTimeBetween" [roomdetails]="roomdetails"
              [auctionRemainingTimeNoBid]="auctionRemainingTimeNoBid" [auctionPause]="auctionPause"
              [isLastItem]="activeAuctionWork==listginItem[listginItem.length-1].id"
              (newBidding)="newBiddingListener($event)"
              (userJoined)="onUserJoinOrWithdraw($event)"></app-multi-live-bidding>
          </p>
        </span>
      </div>
    </div>

    <app-loading
      *ngIf="!listginItem || (!activeAuctionWork && roomdetails.type=='ongoing' && _config.getAuthUserInfo()?.user?.role_code=='General'&& roomdetails.is_me_joined)"></app-loading>



  </div>

</div>